import { useTranslation } from 'react-i18next';

import { SelfPickupIcon } from 'assets';
import { SectionContainer, StyledButton } from 'components/shared';
import ToolTip from 'components/shared/ToolTip/ToolTip';
import { OrderStorageDTO } from 'interfaces';
import { Card } from 'storybook';

import styles from './OverviewStorageSection.module.css';

type OverviewStorageSectionProps = {
   storage: OrderStorageDTO | null;
   onClickEdit?: () => void;
   disabledEditAction?: boolean;
};

const OverviewStorageSection = ({
   storage,
   onClickEdit,
   disabledEditAction,
}: OverviewStorageSectionProps) => {
   const { t } = useTranslation();

   return (
      <SectionContainer title={t('order_summary.storage.title')}>
         {onClickEdit && (
            <ToolTip
               content={t('overviewStorageSection.tooltip')}
               visible={disabledEditAction}
               variant="right"
            >
               <StyledButton
                  text={t('overviewStorageSection.editButton')}
                  variant="outlined-primary"
                  onClick={onClickEdit}
                  disabled={disabledEditAction}
               />
            </ToolTip>
         )}
         <Card
            bottomContent={
               storage?.hasPalletsFromStorage ? (
                  <p className={styles.cardAddress}>
                     {storage.address.street}, {storage.address.zipCode} {storage.address.city} (
                     {t('order_summary.storage.card_title')}{' '}
                     {storage.type === 'EXTERNAL'
                        ? t('storage_type_pl.external')
                        : t('storage_type_pl.internal')}
                     )
                  </p>
               ) : (
                  <p className={styles.noStorageText}>{t('overviewStorageSection.noStorage')}</p>
               )
            }
            className={styles.card}
            icon={<SelfPickupIcon />}
            title={t('order_summary.storage.card_title')}
         />
      </SectionContainer>
   );
};

export default OverviewStorageSection;
